module.exports = __webpack_public_path__ + "static/woman-carrot-thinking-square.0ede1d31.jpg";